import React, { useCallback, useRef, useState } from 'react';
import Modal from '../../Modal/modal';
import NewPatientRetrack from './NewPatientRetrack';
import NewPatientPhotos from '../Photos/NewPatientPhotos';
import { getFormToken } from '../../../util/file';
import axios from '../../../axios-default';
import { useLang } from '../../../util/lang';
import { TextField } from '@material-ui/core';
import classnames from 'classnames';
import AlertDialog from '../../Dialog/Dialog';
import { teethGapConfig } from '../../Teeth/TeethGapConfig';
import TeethSelect from '../../Teeth/TeethSelect/TeethSelect';
import * as actionType from '../../../store/NewPatient/actionType';
import { useDispatch, useSelector } from 'react-redux';
import { teethConfig } from '../../Teeth/TeethConfig';
import { validateImpressionFiles } from '../NewPatientUtill';
import useThreeShapeOnRole from '../../../hooks/useThreeShapeOnRole';

function checkDataNotNull(caseFile) {
    for (let i = 0; i <= 6; i++) {
        const key = `photo${i}`;
        if (caseFile.hasOwnProperty(key)) {
            const photoData = caseFile[key].data;
            if (photoData !== null) {
                return true;
            }
        }
    }
    return false;
}

const Input = ({ props, value, setValue, handleInputChange, label }) => {
    const { classes } = props;
    return (
        <TextField
            className={classnames(classes.textField, classes.dense)}
            variant="standard"
            label={label}
            InputLabelProps={{
                shrink: true,
            }}
            type="number"
            value={value}
            onChange={handleInputChange(setValue)}
        />
    );
};

export const RetrackModal = ({
    open,
    handleClose,
    modalError,
    PhotoUploadLoadingStatus,
    caseId,
    handlePhoto,
    loadingState,
    reloadPage,
    loadingProgress,
    showModalError,
    props,
}) => {
    const get = useLang();
    const errorMessageArray = [
        get('@PatientInfo.modals.question.retrack.error.upper'),
        get('@PatientInfo.modals.question.retrack.error.lower'),
        get('@PatientInfo.modals.question.retrack.error.photo'),
        get('@PatientInfo.modals.question.retrack.error.teethNotTrack'),
    ];
    const dispatch = useDispatch();
    const newPatientData = useSelector((state) => state.newPatientReducer);
    const [upperValue, setUpperValue] = useState('');
    const [lowerValue, setLowervalue] = useState('');
    const [errorMessage, setErrorMessage] = useState(errorMessageArray);
    const [errorDialog, setErrorDialog] = useState(false);
    const errorRef = useRef(null);
    const { threeshapeConnected, setThreeshapeConnected } = useThreeShapeOnRole();

    const handleNewPatientDataError = (errorMsg) => {
        dispatch({ type: actionType.NEW_PATIENT_DATA_ERROR, errorMsg: errorMsg });
    };

    const handleInputChange = (setState) => (event) => {
        const { value } = event.target;
        const regex = /^\d+$/; // Regex pattern to match only non-negative integers

        if (regex.test(value)) {
            setState(value);
        } else {
            setState('');
        }
    };

    const getCaseImpressionCaseFileData = useCallback(() => {
        const form = new FormData();

        let newState = { ...newPatientData };
        let modifiedKey,
            case_file = {},
            case_impression = {},
            teethNotTrack = {},
            teethIncludedGap = {},
            stlCounter = 0,
            newImpressionUpload = {},
            radioCounter = 0;
        let files = newState['files'];
        files.forEach((value, index) => {
            if (value.category == 'stl_file') {
                const fileName = `$$FILE:stl_file${stlCounter}`;
                case_impression['stl_file' + stlCounter] = getFormToken(form, value.data, fileName);
                case_impression['stl_files_later'] = value.will_not_upload ? null : value.upload_later;
                stlCounter++;
            } else if (value.category == 'radio') {
                const fileName = `$$FILE:radio${radioCounter}`;
                case_file['radio' + radioCounter] = {
                    data: getFormToken(form, value.data, fileName),
                    rotate: value.rotate,
                };
                case_file['radio' + radioCounter + '_later'] = value.will_not_upload ? null : value.upload_later;
                radioCounter++;
            } else if (value.category === 'photo') {
                const fileName = `$$FILE:photo${index}`;
                case_file['photo' + index] = {
                    data: getFormToken(form, value.data, fileName),
                    flipped: value.flipped,
                    rotate: value.rotate,
                };
                case_file['photo' + index + '_later'] = value.will_not_upload ? null : value.upload_later;
            }
        });
        Object.keys(newState).forEach(function (key, value) {
            modifiedKey = key
                .replace(/(?:^|\.?)([A-Z])/g, function (x, y) {
                    return '_' + y.toLowerCase();
                })
                .replace(/^_/, '');

            if (
                modifiedKey == 'scanner_brand' ||
                modifiedKey == 'doctor_id' ||
                modifiedKey == 'modern_code' ||
                modifiedKey === 'waybill_number' ||
                modifiedKey === 'courier_company'
            ) {
                if (newState[key] && newState[key].length > 0) {
                    case_impression[modifiedKey] = newState[key];
                }
            }
        });

        newImpressionUpload['case_id'] = caseId;
        newImpressionUpload['doctor_id'] = newPatientData.doctorId;

        teethNotTrack['new_excluded_dentition'] = newPatientData.attachment;
        teethIncludedGap['teethIncludedGap'] = newPatientData.teethIncludedGap;
        case_impression['type'] = newState.impressionType;

        switch (newPatientData.impressionType) {
            case 'FILE': {
                const impressionFiles = newPatientData.files.filter((v) => v.category === 'stl_file');
                const impressionErrList = validateImpressionFiles(impressionFiles);
                if (impressionErrList.length > 0) {
                    handleNewPatientDataError({
                        id: 'impression',
                        msg: get('@NewPatient.warning.allStl'),
                        valid: false,
                    });
                } else {
                    handleNewPatientDataError({ id: 'impression', msg: '', valid: true });
                }
                break;
            }
            case 'COURIER': {
                if (String.isBlank(newPatientData.modernCode)) {
                    handleNewPatientDataError({
                        id: 'impression',
                        msg: get('@NewPatient.warning.courier'),
                        valid: false,
                    });
                } else {
                    handleNewPatientDataError({ id: 'impression', msg: '', valid: true });
                }
                break;
            }
            case 'SCANNER': {
                if (String.isBlank(newPatientData.scannerBrand) || String.isBlank(newPatientData.doctorId)) {
                    handleNewPatientDataError({
                        id: 'impression',
                        msg: get('@NewPatient.warning.scanner'),
                        valid: false,
                    });
                } else {
                    handleNewPatientDataError({ id: 'impression', msg: '', valid: true });
                }
                break;
            }
        }

        return [form, newImpressionUpload, case_impression, case_file, teethNotTrack, teethIncludedGap];
    }, [newPatientData]);

    const loadingStateFunc = useCallback((bool) => {
        loadingState(bool);
    }, []);

    const reloadPageFunc = useCallback(() => {
        reloadPage();
    }, []);

    const showModalErrorFunc = useCallback(() => {
        showModalError();
    }, []);

    const handleDataSave = async () => {
        let errorArray = [];
        try {
            loadingStateFunc(true);
            let [form, newImpressionUpload, case_impression, case_file, teethNotTrack, teethIncludedGap] =
                getCaseImpressionCaseFileData();

            const hasCaseFileData = checkDataNotNull(case_file);
            const isTeethNotTrack = teethNotTrack.new_excluded_dentition.length > 0;
            // const isTeethIncludedGap = teethIncludedGap.teethIncludedGap.length > 0

            const conditions = [
                { condition: !upperValue, errorMessageIndex: 0 },
                { condition: !lowerValue, errorMessageIndex: 1 },
                { condition: !hasCaseFileData, errorMessageIndex: 2 },
                { condition: !isTeethNotTrack, errorMessageIndex: 3 },
            ];

            if (
                hasCaseFileData &&
                upperValue !== '' &&
                lowerValue !== '' &&
                newPatientData.errors[3].valid &&
                isTeethNotTrack
            ) {
                form.append(
                    'body',
                    JSON.stringify({
                        teethNotTrack: teethNotTrack.new_excluded_dentition,
                        teethIncludedGap: teethIncludedGap.teethIncludedGap,
                        case_retrack_detail: {
                            aligner_upper: upperValue,
                            aligner_lower: lowerValue,
                        },
                        case_file: case_file,
                        case_impression: case_impression,
                        newImpressionUpload: newImpressionUpload,
                    })
                );
                setErrorMessage([]);
                const result = await axios.post(`retrack/${caseId}`, form, {
                    onUploadProgress: loadingProgress,
                });

                if (result.data.success) {
                    await props.showSnackbar('Retrack uploaded', 'success', true);
                    handleClose();
                    reloadPageFunc();
                }
            } else {
                conditions.forEach(({ condition, errorMessageIndex }) => {
                    if (condition) {
                        errorArray.push(errorMessageArray[errorMessageIndex]);
                    }
                });

                setErrorMessage(errorArray);
                errorArray.length !== 0 && setErrorDialog(true);
                if (errorRef.current) {
                    errorRef.current.scrollIntoView({ behavior: 'smooth' });
                }
            }
        } catch (err) {
            showModalErrorFunc();
            await props.showSnackbar(err.response.data.message, 'error');
        } finally {
            loadingStateFunc(false);
        }
    };

    return (
        <>
            <Modal
                className="modal"
                modal="RetrackModal"
                title={get('@PatientInfo.case_info.actionsList.retrack')}
                open={open}
                handleClose={handleClose}
                handleDataSave={handleDataSave}
                modalError={modalError}
                PhotoUploadLoadingStatus={PhotoUploadLoadingStatus}
                submitButton={true}
                submitButtonLabel={get('@global.const.submit')}
            >
                <div>
                    <div style={{ marginBottom: 32 }}>{get('@PatientInfo.msg.retrackTip.1')}</div>
                    <div style={{ marginBottom: 32 }}>{get('@PatientInfo.msg.retrackTip.2')}</div>

                    <div style={{ fontWeight: 'bold', marginBottom: 12 }}>
                        {get('@PatientInfo.modals.question.retrack.1.text')}
                    </div>

                    <div>
                        <Input
                            props={props}
                            value={upperValue}
                            setValue={setUpperValue}
                            handleInputChange={handleInputChange}
                            label={'Upper'}
                        />
                    </div>
                    <div>
                        <Input
                            props={props}
                            value={lowerValue}
                            setValue={setLowervalue}
                            handleInputChange={handleInputChange}
                            label={'Lower'}
                        />
                    </div>

                    <div style={{ marginTop: 12, marginBottom: 24 }}>
                        {get('@PatientInfo.modals.question.retrack.1.remark')}
                    </div>

                    <div style={{ fontWeight: 'bold' }}>{get('@PatientInfo.modals.question.retrack.2.text')}: </div>
                    {/* <NewPatientRetrack /> */}
                    <TeethSelect
                        teethConfig={teethConfig}
                        imageNameInPrescriptionNotesFolder={`checkFail`}
                        actionReducer={actionType.NEW_PATIENT_RETRACK_ATTACHMENT}
                        stateReducer={'attachment'}
                    />

                    <div style={{ fontWeight: 'bold', marginTop: 24 }}>
                        {get('@PatientInfo.modals.question.retrack.3.text')}:{' '}
                    </div>
                    <TeethSelect
                        teethConfig={teethGapConfig}
                        imageNameInPrescriptionNotesFolder={`Ellipse`}
                        actionReducer={actionType.NEW_PATIENT_TEETH_INCLUDED_GAP}
                        stateReducer={'teethIncludedGap'}
                    />

                    <NewPatientPhotos tabMode="photos" />
                    <NewPatientPhotos
                        tabMode="impression"
                        uploadLater={'patientInfo'}
                        threeshapeConnected={threeshapeConnected}
                        handleThreeshapeConnected={(value) => setThreeshapeConnected(value)}
                    />

                    <div ref={errorRef} style={{ height: '100%', minHeight: 100 }}>
                        {newPatientData.errors.map((v, i) => {
                            // Error message for impression three tap
                            if (i === 3 && !v.valid) {
                                return (
                                    <div style={{ marginLeft: 12, color: 'red' }} key={`error_${i}`}>
                                        {v.msg}
                                    </div>
                                );
                            }
                        })}
                        {errorMessage.length !== 0 &&
                            errorMessage.map((v, i) => {
                                // Error message except impression
                                return (
                                    <div style={{ marginLeft: 12, color: 'red' }} key={`error_${i}`}>
                                        {v}
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </Modal>
            <AlertDialog
                title="Warning"
                dialogOpen={errorDialog}
                handleDialogClose={() => setErrorDialog(false)}
                content={get('@NewPatient.warning.allMandatory')}
            />
        </>
    );
};
